// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { component } from 'picoapp';

export default component(async (node: HTMLElement, ctx: any) => {
  ctx.on('product-grid-view', ({ value }: { value: string }) => {
    node.dataset.productItemLayout = value;
  });
});
